import { render, staticRenderFns } from "./DashboardLeastActiveUsers.vue?vue&type=template&id=5a792f15&scoped=true"
import script from "./DashboardLeastActiveUsers.vue?vue&type=script&lang=js"
export * from "./DashboardLeastActiveUsers.vue?vue&type=script&lang=js"
import style0 from "./DashboardLeastActiveUsers.vue?vue&type=style&index=0&id=5a792f15&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a792f15",
  null
  
)

export default component.exports